/**
 * Created by 1 on 2018/1/15.
 * 重复点展示图层
 */
'use strict';
/**
 * 点状分布图层
 * @module PointDuplicateLayer
 */
define([
    './PointLayer',
    '../misc/SpiderfyHelper',
    '../utils/CommonUtil',
    '../utils/GeometryUtil',
    '../misc/DistanceGrid',
    '../utils/LoggerUtil',
    '../g2'
],function(
    PointLayer,
    SpiderfyHelper,
    CommonUtil,
    GeometryUtil,
    DistanceGrid,
    LoggerUtil,
    g2
) {
    /**
     * 构造方法
     * @constructor
     * @classdesc 点图层
     * @augments G.lys.DistributeLayer
     * @alias G.lys.PointDuplicateLayer
     * @param {Object} options - 必填，构造参数；
     * @param {G.Map/g2.carto.Map} options.map -必填，地图对象
     * @param {String} options.layerId - 可选，图层id，默认为随机字符串
     * @param {String} options.idKey - 必填，数据记录中作为唯一标识的字段名
     * @param {String} options.attributeField - 可选，数据记录中属性信息挂接的属性名，默认为空
     * @param {String} options.geometryField - 可选，数据记录中空间属性名，默认为空，如果有值，则几何使用数据记录中对应的坐标信息；
     * @param {String} options.xField - 可选，数据记录中x坐标字段名，默认为LONGITUDE
     * @param {String} options.yField - 可选，数据记录中y坐标字段名，默认为LATITUDE
     * @param {Object} options.symbolConfig - 必填，符号配置
     * @param {String} options.defaultSymbolKey - 可选，符号配置文件中默认符号的key值，默认为default
     * @param {Number} options.spatialReference - 可选，图层坐标系，默认4326
     * @param {Number} options.dataSpatialReference - 可选，叠加数据的坐标系，默认图层坐标系
     * @param {Function} options.symbolUpdateCallback - 可选，地图显示的符号更新时的回调，
     * @param {Number} options.spiderfyDistance - 可选，重复点识别的像素距离；
     * @param {Number} options.spiderfyLevel - 可选，重复点自动排列的级别；
     * @param {Number} options.enableCoincidenceClusterLevel - 可选，显示聚合图标的级别,值为比例尺范围字符串；默认为[0,10000]
     * @param {Number} options.coincidenceClusterHoverThreshold - 可选，重复点自动排列的级别；
     * @param {Number} options.coincidenceClusterWeight - 可选，显示聚合图标的级别,值为比例尺范围字符串；默认为[0,10000]
     * @param {Number} options.coincidenceClusterMarkerSym - 可选，默认聚合点样式；
     * @param {Number} options.coincidenceClusterTextSym - 可选，默认文字的样式；
     * @param {Number} options.showSpiderLeg - 可选，是否显示重复点排列的连线,默认为true；
     * @param {Number} options.spiderfyThreshold - 可选，超过这个值的点用螺旋，否则用圆排布；默认5，单位像素
     * @param {Number} options.circleRadius - 可选，圆排布的半径；默认30，单位像素
     * @param {Number} options.spiderfyLegSym - 可选，连线的符号样式；
     * @param {Object} options.callbackContext - 可选，回调的上下文
     * @returns {Class} - 实例化的对象
     */
    var layer = PointLayer.extend({
        options:{
            //重复点识别的像素距离；
            spiderfyDistance:1,
            //重复点自动排列的级别；
            spiderfyLevel:10,
            //允许重复点排列；显示聚合图标的级别,值为比例尺范围字符串；
            enableCoincidenceClusterLevel:'[0,10000]',
            //聚合效果时，鼠标滑过展开的最多个数
            coincidenceClusterHoverThreshold:15,
            //聚合尺寸与字体大小比例
            coincidenceClusterWeight:1.2,
            //默认聚合点样式
            coincidenceClusterMarkerSym:{
                "borderColor":{
                    "alpha": 150, "r": 150, "g": 120, "b": 226
                },
                "fillColor":{
                    "alpha": 220, "r": 106, "g": 63, "b": 214
                }
            },
            //默认文字的样式
            coincidenceClusterTextSym:{
                "fontSize":12,
                "foreground": {"alpha": 255, "r": 255, "g": 255, "b": 255},
                "borderColor":{"alpha": 1, "r": 255, "g": 255, "b": 255}
            },
            //是否显示重复点排列的连线,默认为true
            showSpiderLeg:true,
            //超过这个值的点用螺旋，否则用圆排布；
            spiderfyThreshold:5,
            //圆排布的半径
            circleRadius:30,
            //连线的符号
            spiderfyLegSym:{
                "style":0,
                "width":2,
                "color":{"alpha":"150","r":0,"g":0,"b":255}
            }
        },
        initialize:function(options){
            PointLayer.prototype.initialize.call(this,options);
            //
            // this.options.spiderfyDistance=1;
            this.options.enalbeSpiderfy=true;
            this.options.enableCoincidenceCluster=true;
            //
            SpiderfyHelper.init.call(this);
        },
        destroy:function(){
            this._clearSpiderfy(true);
            PointLayer.prototype.destroy.call(this);
        },
        /**
         * 批量添加点
         * @method
         * @memberOf G.lys.PointLayer.prototype
         * @param {Array} dataArr - 必填，数据数组
         * @param {Object} options - 可选
         * @param {Number} options.dataSpatialReference -可选，数据的坐标系，默认为图层的坐标系
         */
        addElements:function(dataArr,options){
            if(!CommonUtil.isArray(dataArr)){
                LoggerUtil.error('dataArr is not an array');
                return ;
            }
            options=options||{};
            //
            var zoom=this.map.getZoomLevel();
            //坐标不正确的数据
            var spatialReference=this.options.spatialReference,
                dataSpatialReference=options.dataSpatialReference||
                    this.options.dataSpatialReference;
            //主键标识字段名
            var spiderfyFlag=false;
            //判断是否显示自动排列
            if(this.options.enalbeSpiderfy){
                if(zoom>=this.options.spiderfyLevel){
                    spiderfyFlag='spiderfy';
                }else {
                    if(this.options.enableCoincidenceCluster){
                        if(CommonUtil.assertWithin(
                                this.map.getZoomLevel(),this.options.enableCoincidenceClusterLevel)){
                            spiderfyFlag='cluster';
                        }
                    }
                }
            }
            //遍历数据
            for(var i=0,len=dataArr.length;i<len;i++){
                var data=dataArr[i];
                //获取坐标
                var point=this._getGeometry(data,dataSpatialReference,spatialReference);
                //坐标无效，记录无效数据；
                if(!this.validateGeometry(point)){
                    this.noneSpatialArr.push(data);
                    continue;
                }
                //根据数据和比例尺获取符号
                var symbolObj=this._getSymbol(data,zoom),
                    elementId=this._getRecordId(data);
                var ele = new g2.sfs.Element({
                    id:elementId,
                    geometry: point,
                    symbol: symbolObj.symbol
                });
                //保存数据
                ele._data=data;
                //当前符号的比例尺级别范围；
                ele._zoomRange=symbolObj.zoomRange;
                //保存当前符号的symbolkey
                ele._symbolKey=symbolObj.symbolKey;
                //保存添加的元素
                this.elements.push(ele);
                //满足自动排列或者聚合的条件，不添加到图层；
                if(spiderfyFlag){
                    continue;
                }
                //添加到图层
                this.layer.add(ele);
                //test position
                // var testSym = new g2.sfs.SimpleMarkerSymbol({
                //         fillColor: new g2.sfs.Color({a: 255, r: 255, g:0, b: 0}),
                //         size: 2
                //     }
                // );
                // var testEl = new g2.sfs.Element({geometry: point, symbol: testSym});
                // this.layer.add(testEl);
            }
            //重复点排列
            if(spiderfyFlag){
                this._updateSpiderfy(spiderfyFlag);
            }
            //notify symbol updated
            this._onSymbolsUpdated();
            //notify elements changed
            this._onElementChanged();
        },
        /**
         * 地图点击事件
         * @method
         * @memberOf G.lys.DistributeLayer.prototype
         * @param {Number} screenX - 必填，元素的id
         * @param {Number} screenY - 必填，元素的id
         * @returns {Function}
         */
        hitTest:function(screenX, screenY){
            var hitList=[];
            var ele=this.layer.hitTest(screenX, screenY);
            if(ele){
                hitList.push(ele);
            }
            if(this.coincidenceHoverLayer){
                var ele=this.coincidenceHoverLayer.hitTest(screenX,screenY);
                if(ele){
                    hitList.push(ele);
                }
            }
            return hitList[0]||null;
        },
        /**
         * 清空图层
         * @method
         * @memberOf G.lys.PointLayer.prototype
         */
        clear:function(){
            this._clearSpiderfy();
            this.elements=[];
            //
            PointLayer.prototype.clear.call(this);
        },
        /**
         * 控制显影
         * @method
         * @memberOf G.lys.PointLayer.prototype
         * @param {Boolean} visible - 必填，是否可见
         */
        setVisible:function(visible){
            this.layer.setVisible(visible||false);
            if(this.options.enalbeSpiderfy){
                if(this.spiderfyAttachLayer){
                    this.spiderfyAttachLayer.setVisible(visible||false);
                }
                if(this.coincidenceClusterLayer){
                    this.coincidenceClusterLayer.setVisible(visible||false);
                }
                if(this.coincidenceHoverLayer){
                    this.coincidenceHoverLayer.setVisible(visible||false);
                }
            }
            //更新图例
            if(visible){
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:this.currentSymbols
                });
            }else{
                this.invokeCallback('symbolUpdateCallback',{
                    layerId:this.options.layerId,
                    symbols:[]
                });
            }
        }
    });

    layer.include({
        _extentChangeListener:function(){
            var currentZoom=this.map.getZoomLevel();
            if(currentZoom===this.currentZoom){
                return;
            }
            //更新符号
            this.updateSymbol(currentZoom);
            //自动排列处理
            var flag=this._applySpiderfy(this.currentZoom,currentZoom);
            if(flag){
                if(this.currentClusterObj!=null){
                    var newCurrentClusterElementId=this._getCurrentClusterElementIdOnUpdate();
                    if(newCurrentClusterElementId!=null){
                        this.coincidenceHoverLayer.clear();
                        var clusterElement=this.coincidenceClusterLayer.find(newCurrentClusterElementId);
                        if(clusterElement){
                            this._addHoverSpiderfy(clusterElement);
                            this.currentClusterObj=this._extractClusterElement(clusterElement);
                            this._toggleCurrentClusterElement(false);
                        }
                    }
                }
                this.fire('clusterChange',jQuery.extend(true,{},this.currentClusterObj));
            }
            //update current zoom
            this.currentZoom=currentZoom;
        },
        _mapClickListener:function(event){
            var dEle=this.hitTest(event.screenX, event.screenY),
                distributeEleClicked=false;
            var needToggleClusterElement=true;
            if(dEle){
                this.fire('click',{
                    element:dEle.element,
                    layer:dEle.layer
                });
                distributeEleClicked=true;
                //判断是否需要显示聚合图标
                needToggleClusterElement=this._applyToggleCurrentClusterElement(dEle.element);
            }
            if(needToggleClusterElement){
                this._toggleCurrentClusterElement(true);
                this.coincidenceHoverLayer.clear();
            }
            if(distributeEleClicked){
                return;
            }
            //点中重复点图层
            if(this.coincidenceClusterLayer){
                var ele=this.coincidenceClusterLayer.hitTest(event.screenX, event.screenY);
                if(ele){
                    var element=ele.element;
                    if(element){
                        var flag=this._addHoverSpiderfy(element);
                        if(flag){
                            //保存当前点击的聚合元素
                            this.currentClusterObj=this._extractClusterElement(element);
                            this._toggleCurrentClusterElement(false);
                        }
                        return;
                    }
                }
            }
        },
        /**
         * 根据id从layer中获取元素和图层对象；
         * @method
         * @private
         * @param layer
         * @param id
         * @returns {*}
         */
        _getLayerElementById:function(layer,id){
            var elements=this.elements;
            for(var key in elements){
                var element=elements[key];
                if(element.id==id){
                    return {
                        element:element,
                        layer:layer
                    };
                }
            }
        },
        /**
         * 获取多个元素的几何中心
         * @param eles
         * @returns {Array}
         * @private
         */
        _getElementsCenter:function(eles){
            var x= 0, y=0,len=eles.length;
            for(var k=0;k<len;k++){
                var e=eles[k];
                x+=e.geometry.x;
                y+=e.geometry.y;
            }
            return [x/len,y/len];
        }
    });
    SpiderfyHelper.include(layer);
    /**
     * 定义图层类型
     */
    Object.defineProperty(layer,'type',{
        value:14,
        configurable:false,
        writable:false
    });
    return layer;
});
